<div class="menu" id="menu">
  <ul class="menu-list">
    <li class="menu-item">
      <button
        mat-button
        aria-label="Unassigned Work Orders"
        (click)="setFilterState('Unassigned')"
      >
        <div
          class="state-content"
          [ngClass]="{ 'is-active': (selectedState$ | async) == 'Unassigned' }"
        >
          <div class="counter-position">
            <mat-icon [inline]="true" class="menu-icon"
              >assignment_late
            </mat-icon>
            <span class="state-counter"
              >{{ unassignedStateCounter$ | async }}
            </span>
          </div>
          <span class="menu-name">
            {{ "workorders.filters.unassigned" | translate }}
          </span>
        </div>
      </button>
    </li>
    <li class="menu-item">
      <button
        mat-button
        aria-label="Assigned Work Orders"
        (click)="setFilterState('Assigned')"
      >
        <div
          class="state-content"
          [ngClass]="{ 'is-active': (selectedState$ | async) == 'Assigned' }"
        >
          <div class="counter-position">
            <mat-icon [inline]="true" class="menu-icon">
              assignment_ind
            </mat-icon>
            <span class="state-counter">
              {{ assignedStateCounter$ | async }}
            </span>
          </div>
          <span class="menu-name">
            {{ "workorders.filters.assigned" | translate }}
          </span>
        </div>
      </button>
    </li>
    <li class="menu-item">
      <button
        mat-button
        aria-label="Ongoing Work Orders"
        (click)="setFilterState('Working')"
      >
        <div
          class="state-content"
          [ngClass]="{ 'is-active': (selectedState$ | async) == 'Working' }"
        >
          <div class="counter-position">
            <mat-icon [inline]="true" class="menu-icon">assignment</mat-icon>
            <span class="state-counter"
              >{{ workingStateCounter$ | async }}
            </span>
          </div>
          <span class="menu-name">
            {{ "workorders.filters.working" | translate }}
          </span>
        </div>
      </button>
    </li>
    <li class="menu-item">
      <button
        mat-button
        aria-label="Finished Work Orders"
        (click)="setFilterState('Finished')"
      >
        <div
          class="state-content"
          [ngClass]="{ 'is-active': (selectedState$ | async) == 'Finished' }"
        >
          <div class="counter-position">
            <mat-icon [inline]="true" class="menu-icon"
              >assignment_returned
            </mat-icon>
            <span class="state-counter">{{
              finishedStateCounter$ | async
            }}</span>
          </div>
          <span class="menu-name">
            {{ "workorders.filters.finished" | translate }}
          </span>
        </div>
      </button>
    </li>
    <li class="menu-item">
      <button
        mat-button
        aria-label="Validated Work Orders"
        (click)="setFilterState('Validated')"
      >
        <div
          class="state-content"
          [ngClass]="{ 'is-active': (selectedState$ | async) == 'Validated' }"
        >
          <div class="counter-position">
            <mat-icon [inline]="true" class="menu-icon">
              assignment_turned_in
            </mat-icon>
            <span class="state-counter">
              {{ validatedStateCounter$ | async }}
            </span>
          </div>
          <span class="menu-name">
            {{ "workorders.filters.validated" | translate }}
          </span>
        </div>
      </button>
    </li>
  </ul>
</div>
